import axios from 'axios';
const API_URL = `https://kinoadmin.freemyip.com/api`
//const API_URL = `http://127.0.0.1:8001/api`

const fetchMovieById = async (id) => {
    const response = await axios.get(`${API_URL}/movie/${id}`);
    return response.data[0];
};


const fetchMovies = async () => {
   
        const response = await axios.get(`${API_URL}/price/`);
        return response.data;
};


const fetchMoviesNow = async () => {
   
    const response = await axios.get(`${API_URL}/now/`);
    return response.data;
};

const fetchMoviesSoon = async () => {
   
    const response = await axios.get(`${API_URL}/soon/`);
    return response.data;
};


const fetchMoviesDraft = async () => {
   
    const response = await axios.get(`${API_URL}/draft/`);
    return response.data;
};

const fetchBanners = async () => {
   
    const response = await axios.get(`${API_URL}/moviesprice/`);
    return response.data;
};

const fetchRandomBanners = async () => {
   
    const response = await axios.get(`${API_URL}/banersall/`);
    return response.data;
};

const fetchNews = async () => {
   
    const response = await axios.get(`${API_URL}/newses3/`);
    return response.data;
};

const fetchNewsById = async (id) => {
   
    const response = await axios.get(`${API_URL}/news/${id}?format=json`);
    return response.data[0];
};




const fetchAlbum = async () => {
   
    const response = await axios.get(`${API_URL}/drugbaimgs/`);
    return response.data;
};

export { fetchMovieById };
export { fetchMovies };
export { fetchBanners };
export { fetchMoviesNow };
export { fetchMoviesSoon };
export { fetchMoviesDraft };
export { fetchNews };
export { fetchNewsById };
export { fetchAlbum };
export { fetchRandomBanners };